import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { TcLoggerInterface } from '../logger/tc-logger.interface';

@Injectable({
  providedIn: 'root',
})
export class TcLoggerService extends NGXLogger implements TcLoggerInterface {}
